import { render } from "./PurchaseOrders.vue?vue&type=template&id=70432605"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PurchaseOrders/PurchaseOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70432605"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70432605', __exports__)) {
    api.reload('70432605', __exports__)
  }
  
  module.hot.accept("./PurchaseOrders.vue?vue&type=template&id=70432605", () => {
    api.rerender('70432605', render)
  })

}


export default __exports__